import { ExportFile } from '../types/export/export';
import {
  TaskExportConfiguration,
  CreateTaskExportConfigurationInput,
  UpdateTaskExportConfigurationInput,
  DeleteTaskExportConfigurationInput,
} from '../types/task_export_configuration';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const EXPORT = '/api/task/export';
const CONFIGURATIONS = '/api/task/export/list';
const CREATE_CONFIGURATION = '/api/task/export/create';
const UPDATE_CONFIGURATION = '/api/task/export/update';
const DELETE_CONFIGURATION = '/api/task/export/delete';

export namespace TaskExportConfigurationRequest {
  export interface TaskExportPayload {
    taskId: string;
    configId?: string;
    timezone?: string;
    locale?: string;
  }

  export const download = async (payload: TaskExportPayload): Promise<ExportFile> => {
    return (await http.post(EXPORT, payload)).data;
  };

  export const list = async (payload: { page: number }): Promise<PaginatedResponse<TaskExportConfiguration>> => {
    return (await http.post(CONFIGURATIONS, payload)).data;
  };

  export const create = async (payload: {
    data: CreateTaskExportConfigurationInput[];
  }): Promise<TaskExportConfiguration[]> => {
    return (await http.post(CREATE_CONFIGURATION, payload)).data;
  };

  export const update = async (payload: {
    data: UpdateTaskExportConfigurationInput[];
  }): Promise<TaskExportConfiguration[]> => {
    return (await http.post(UPDATE_CONFIGURATION, payload)).data;
  };

  export const remove = async (payload: {
    data: DeleteTaskExportConfigurationInput[];
  }): Promise<TaskExportConfiguration[]> => {
    return (await http.post(DELETE_CONFIGURATION, payload)).data;
  };
}
